<app-system-state-panel></app-system-state-panel>
<router-outlet></router-outlet>
<div *ngIf="sessionExpiredVisible$ | async" class="session-expired-overlay">
  <div class="session-expired-modal">
    <h3>Session Expired</h3>
    <p>Your session has expired. Please login again to continue.</p>
    <button type="button" (click)="loginAgain()">Login Again</button>
  </div>
</div>
